import { clearElementValue, deleteComponent, updateElementIndex } from '@/core/item_assistance/creatingNewComponents'
import { CopyToClipboard } from '@/core/shared'
import { initDataInLabel } from '@/core/item_assistance/initializeComponentData'

export function showLangsList (id, element) {
	var areaId = '#' + id + '__area'
	var list = $(areaId).find('> select.langs-list')
	$(list).css('display', 'inline')
	var button = $(areaId).find('> button')
	$(list).offset({
		top: $(button).offset().top,
		left: $(button).offset().left
	})
	if (element) {
		$(list).offset({
			top: $(element).offset().top + parseInt($(element).css('height')),
			left: $(element).offset().left + parseInt($(element).css('width')) - parseInt($(list).css('width'))
		})
	}
	$(list).val($(list).children().first().text())

	$(list).bind('keydown.return', function () {
		$(list).click()
	})

	$(list).focus()
}

export function hideLangsList (id) {
	var areaId = '#' + id + '__area'
	var list = $(areaId).find('> select.langs-list')
	if ($(list).is(':visible')) {
		$(list).css('display', 'none')
		$(list).unbind('keydown.return')
	}
}

export function copyComponentSL (id) {
	hideLangsList(id)
	var areaId = '#' + id + '__area'
	var lastRow = $(areaId).children().last()
	var lastSingleOfRow = $(lastRow).children().last()
	var selectedLang = $(areaId).find('> select.langs-list').val()
	var exists = false
	$(lastRow).children().each(function (index, element) {
		var label = $(element).children().first().children('label').first()
		if ($(label).attr('value') == selectedLang) {
			$(element).find('.attribute-editor').focus()
			exists = true
			return false
		}
	})
	if (!exists) {
		var $editor = $(lastSingleOfRow).children().first().children('.attribute-editor').first()
		if ($editor.val() == '') {
			var label = $(lastSingleOfRow).children().first().children('label').first()
			initDataInLabel($(label).attr('id'), selectedLang, selectedLang)
			if ($editor.hasClass('dictionary-list')) {
				$editor.html($(areaId).find('.lang-' + selectedLang).html())
			}
			$editor.focus()
		} else {
			copyComponentSLWithoutCheck(id, selectedLang)
		}
	}
}

function copyComponentSLWithoutCheck (id, lang) {
	var area = '#' + id + '__area'
	var lastSingleOfRow = $(area).children().last().children().last()
	var newElement = $(lastSingleOfRow).clone()
	newElement = clearElementValue($(newElement))
	var newLangList = $(area).find('.lang-' + lang)
	var oldLangList = newElement.find('.dictionary-list')
	if (newLangList && oldLangList) {
		oldLangList.html(newLangList.html())
	}
	var newIndex = parseInt($(newElement).attr('data-attribute-index')) + 1
	newElement = updateElementIndex($(newElement), newIndex, id)
	newElement = bindElementEventsSL($(newElement), $(area))
	$(lastSingleOfRow).after($(newElement))
	var label = $(newElement).children().first().children('label').first()
	label.parent().find('span.label-copy-icon').remove()
	var classHiddenElement = ''
	if (!editableTradeItem.getEnableCopyAttributeName()) {
		classHiddenElement = 'dn'
	}
	label.after('<span class="fa fa-files-o label-copy-icon ' + classHiddenElement + '" onclick="CopyToClipboard(\'' + id + '\', this)"></span>')
	initDataInLabel($(label).attr('id'), lang, lang)
	$(newElement).find('.attribute-editor').focus()
}

function bindElementEventsSL (element, area) {
	$(element).find('.button_minus').bind('click', function () {
		deleteComponent($(area), $(element))
	})
	return $(element);
}
